import React, { useEffect, useState, useRef } from "react";
import defaultAvatar from "../../assets/user.png";
import { useDispatch, useSelector } from "react-redux";
import api from "../../utilis/api";
import { toast } from "react-toastify";
import { online, url } from "../../utilis/contant";
import { loginSuccess } from "../../redux/reducer/authSlice";

/* ─── inline styles kept in JS so no extra CSS file needed ─── */
const S = {
  page: {
    minHeight: "100vh",
    background: "#0a0a0a",
    padding: "2rem",
    fontFamily: "'Segoe UI', sans-serif",
    color: "#fff",
  },
  header: {
    marginBottom: "2.5rem",
  },
  sub: {
    fontSize: "12px",
    letterSpacing: "0.12em",
    textTransform: "uppercase",
    color: "#e6be5d",
    marginBottom: "6px",
  },
  title: {
    fontSize: "clamp(1.5rem, 3vw, 2rem)",
    fontWeight: 700,
    margin: 0,
    color: "#fff",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "240px 1fr",
    gap: "2rem",
    alignItems: "start",
    background: "#111",
    border: "1px solid #222",
    borderRadius: "16px",
    padding: "2rem",
    marginBottom: "2rem",
  },
  photoCol: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "1rem",
  },
  photoWrap: {
    position: "relative",
    width: "140px",
    height: "140px",
  },
  photo: {
    width: "140px",
    height: "140px",
    borderRadius: "50%",
    objectFit: "cover",
    border: "3px solid #e6be5d",
  },
  photoOverlay: {
    position: "absolute",
    inset: 0,
    borderRadius: "50%",
    background: "rgba(0,0,0,0.55)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    opacity: 0,
    transition: "opacity 0.2s",
    gap: "4px",
  },
  photoOverlayText: {
    color: "#e6be5d",
    fontSize: "12px",
    fontWeight: 600,
  },
  nameTag: {
    fontWeight: 700,
    fontSize: "15px",
    textAlign: "center",
    color: "#fff",
  },
  roleTag: {
    fontSize: "12px",
    color: "#e6be5d",
    background: "rgba(230,190,93,0.12)",
    border: "1px solid rgba(230,190,93,0.3)",
    borderRadius: "20px",
    padding: "3px 12px",
    textTransform: "capitalize",
  },
  fields: {
    display: "flex",
    flexDirection: "column",
    gap: "14px",
  },
  label: {
    fontSize: "11px",
    fontWeight: 600,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "#888",
    marginBottom: "4px",
    display: "block",
  },
  input: {
    width: "100%",
    background: "#1a1a1a",
    border: "1px solid #2a2a2a",
    borderRadius: "10px",
    padding: "10px 14px",
    color: "#fff",
    fontSize: "14px",
    outline: "none",
    boxSizing: "border-box",
    transition: "border-color 0.2s",
  },
  textarea: {
    width: "100%",
    background: "#1a1a1a",
    border: "1px solid #2a2a2a",
    borderRadius: "10px",
    padding: "10px 14px",
    color: "#fff",
    fontSize: "14px",
    outline: "none",
    boxSizing: "border-box",
    resize: "vertical",
    minHeight: "100px",
    fontFamily: "inherit",
  },
  btnGold: {
    background: "linear-gradient(135deg, #e6be5d, #c9a23a)",
    color: "#000",
    border: "none",
    borderRadius: "10px",
    padding: "11px 24px",
    fontWeight: 700,
    fontSize: "14px",
    cursor: "pointer",
    letterSpacing: "0.03em",
  },
  btnGhost: {
    background: "transparent",
    color: "#888",
    border: "1px solid #333",
    borderRadius: "10px",
    padding: "9px 18px",
    fontWeight: 600,
    fontSize: "13px",
    cursor: "pointer",
  },
  card: {
    background: "#111",
    border: "1px solid #222",
    borderRadius: "16px",
    padding: "2rem",
    marginBottom: "2rem",
  },
  cardTitle: {
    fontSize: "15px",
    fontWeight: 700,
    color: "#fff",
    marginBottom: "1.5rem",
    paddingBottom: "12px",
    borderBottom: "1px solid #1e1e1e",
  },
  skillsWrap: {
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
    marginBottom: "10px",
  },
  skillTag: {
    background: "rgba(230,190,93,0.1)",
    border: "1px solid rgba(230,190,93,0.3)",
    color: "#e6be5d",
    borderRadius: "20px",
    padding: "4px 12px",
    fontSize: "12px",
    fontWeight: 600,
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },
  skillInput: {
    flex: 1,
    minWidth: "140px",
    background: "#1a1a1a",
    border: "1px solid #2a2a2a",
    borderRadius: "8px",
    padding: "8px 12px",
    color: "#fff",
    fontSize: "13px",
    outline: "none",
  },
  videoBox: {
    background: "#0d0d0d",
    border: "2px dashed #2a2a2a",
    borderRadius: "12px",
    padding: "2rem",
    textAlign: "center",
    cursor: "pointer",
    transition: "border-color 0.2s",
  },
  videoPreview: {
    width: "100%",
    borderRadius: "10px",
    marginTop: "1rem",
    maxHeight: "260px",
    background: "#000",
  },
  row: {
    display: "flex",
    gap: "12px",
    alignItems: "center",
    marginTop: "1rem",
  },
  successBadge: {
    color: "#22c55e",
    fontSize: "12px",
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  videoContainer: {
    width: "500px",
    height: "400px",
    borderRadius: "12px",
    padding: "1rem 1rem",
    overflow: "hidden",
    background: "#000",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    marginBottom: "1rem",
  },
};

export default function TProfile() {
  const { user, token } = useSelector((s) => s.auth);
  const dispatch = useDispatch();

  const photoInputRef = useRef(null);
  const videoInputRef = useRef(null);
  const thumbnailInputRef = useRef(null);

  const [teacher, setTeacher] = useState(null);
  const [loadingTeacher, setLoadingTeacher] = useState(true);
  const [photoPreview, setPhotoPreview] = useState(null);
  const [photoFile, setPhotoFile] = useState(null);
  const [photoHover, setPhotoHover] = useState(false);
  const [comment, setComment] = useState(null);
  const [show, setShow] = useState(false);
  const [profile, setProfile] = useState({
    name: user?.name || "",
    email: user?.email || "",
    phone: user?.phone || "",
  });

  const [teacherProfile, setTeacherProfile] = useState({
    bio: "",
    skills: [],
    introVideoFile: null,
    introVideoPreview: null,
    videoPlaying: false,
    thumbnail: null,
    videoThumbnail: null, // auto generated preview image
  });

  const [skillInput, setSkillInput] = useState("");
  const [savingProfile, setSavingProfile] = useState(false);
  const [savingTeacher, setSavingTeacher] = useState(false);

  // Keep profile fields in sync with Redux user
  useEffect(() => {
    if (user) {
      setProfile({
        name: user.name || "",
        email: user.email || "",
        phone: user.phone || "",
        image: user.image || " ",
      });
    }
  }, [user]);

  const getTeacher = async () => {
    if (!user?._id) return;
    setLoadingTeacher(true);
    try {
      const res = await api.get("/teacher/" + user._id);
      const data = res.data?.data;
      if (data) {
        setTeacher(data);
        setTeacherProfile({
          bio: data.bio || "",
          skills: Array.isArray(data.skills) ? data.skills : [],
          introVideo: data.introVideo
            ? data.introVideo.replace(/^\/+/, "")
            : "",
          thumbnail: data.thumbnail?.replace(/^\/+/, "") || "",
          introVideoFile: null,
          introVideoPreview: null,
          videoPlaying: false, // 🔥 IMPORTANT
          videoThumbnail: null,
        });
      }
    } catch (err) {
      console.error("Error fetching teacher:", err);
    } finally {
      setLoadingTeacher(false);
    }
  };

  useEffect(() => {
    getTeacher();
  }, []);

  /* ── Photo ── */
  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setPhotoFile(file);
    setPhotoPreview(URL.createObjectURL(file));
  };

  const handleChange = (e) =>
    setProfile((p) => ({ ...p, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!profile.name || !profile.email) {
      toast.error("Name and email are required");
      return;
    }
    setSavingProfile(true);
    try {
      const fd = new FormData();
      fd.append("name", profile.name);
      fd.append("email", profile.email);
      fd.append("phone", profile.phone);
      if (photoFile) fd.append("file", photoFile);

      const res = await api.put(`/user/${user._id}`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (res.data.success) {
        const u = res.data.data;
        dispatch(loginSuccess({ user: u, token, role: u.role }));
        localStorage.setItem("user", JSON.stringify(u));
        localStorage.setItem("role", u.role);
        setPhotoFile(null);
        setPhotoPreview(null);
        toast.success("Profile updated!");
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to update profile");
    } finally {
      setSavingProfile(false);
    }
  };

  const generateVideoThumbnail = (file) => {
    return new Promise((resolve) => {
      const video = document.createElement("video");
      video.src = URL.createObjectURL(file);

      video.onloadedmetadata = () => {
        video.currentTime = 1;
      };

      video.onseeked = () => {
        const canvas = document.createElement("canvas");
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

        resolve(canvas.toDataURL("image/png"));
      };
    });
  };
  /* ── Video ── */
  const handleVideoChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const thumb = await generateVideoThumbnail(file);

    setTeacherProfile((p) => ({
      ...p,
      introVideoFile: file,
      introVideoPreview: URL.createObjectURL(file),
      videoThumbnail: thumb,
    }));
  };

  /* ── Skills ── */
  const addSkill = (e) => {
    e.preventDefault();
    const s = skillInput.trim();
    if (s && !teacherProfile.skills.includes(s)) {
      setTeacherProfile((p) => ({ ...p, skills: [...p.skills, s] }));
      setSkillInput("");
    }
  };

  const removeSkill = (idx) =>
    setTeacherProfile((p) => ({
      ...p,
      skills: p.skills.filter((_, i) => i !== idx),
    }));

  const handleThumbnailChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setTeacherProfile((p) => ({
      ...p,
      thumbnail: file,
    }));
  };
  /* ── Save teacher ── */
  const handleTeacherSubmit = async (e) => {
    e.preventDefault();
    setSavingTeacher(true);
    try {
      const fd = new FormData();
      fd.append("bio", teacherProfile.bio || "");
      fd.append("userId", user._id);
      teacherProfile.skills.forEach((s) => fd.append("skills[]", s));
      if (teacherProfile.introVideoFile) {
        fd.append("introVideo", teacherProfile.introVideoFile);
      }

      if (teacherProfile.thumbnail) {
        fd.append("thumbnail", teacherProfile.thumbnail);
      }

      const method = teacher?._id ? "put" : "post";
      const endpoint = teacher?._id ? "/teacher/" + teacher._id : "/teacher/";

      const res = await api[method](endpoint, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (res.data.success) {
        const d = res.data.data;
        setTeacher(d);
        setTeacherProfile({
          bio: d.bio || "",
          skills: Array.isArray(d.skills) ? d.skills : [],
          introVideo: d.introVideo ? d.introVideo.replace(/^\/+/, "") : "",
          introVideoFile: null,
          introVideoPreview: null,
        });
        toast.success("Teacher profile saved!");
      }
    } catch (err) {
      console.log(err);
      toast.error(
        err.response?.data?.message || "Failed to update teacher profile",
      );
    } finally {
      setSavingTeacher(false);
    }
  };

  /* ── Src helpers ── */
  const photoSrc = () => {
    if (photoPreview) return photoPreview;
    if (user?.image) {
      if (user.image.startsWith("http")) return user.image;

      return `${url}/${user.image.replace(/^\/+/, "")}`;
    }
    return defaultAvatar;
  };

  console.log(url, photoSrc());
  const videoSrc = () => {
    if (teacherProfile.introVideoPreview)
      return teacherProfile.introVideoPreview;
    if (teacherProfile.introVideo) return `${url}/${teacherProfile.introVideo}`;
    return null;
  };
  const thumbnailSrc = () => {
    if (teacherProfile.videoThumbnail) return teacherProfile.videoThumbnail; // generated
    if (teacherProfile.thumbnail instanceof File)
      return URL.createObjectURL(teacherProfile.thumbnail);
    if (teacherProfile.thumbnail) return `${url}/${teacherProfile.thumbnail}`;
    return null;
  };
  // Get Comments
  const fetchComments = async () => {
    try {
      const teacherId = teacher._id;
      console.log(teacherId);
      const res = await api.get(`/review/teacher/${teacherId}`);
      if (res.data) {
        console.log(res.data);
        setComment(res.data);
      }
    } catch (err) {
      console.error("Failed to fetch booked slots:", err);
    }
  };

  useEffect(() => {
    if (teacher?._id) {
      fetchComments();
    }
  }, [teacher]);
  const getInitials = (name) => {
    if (!name) return "";
    const names = name.split(" ");
    return names
      .map((n) => n[0]?.toUpperCase())
      .join("")
      .slice(0, 2); // Max 2 letters
  };
  return (
    <div className="teacher-profile-page" style={S.page}>
      {/* Header */}
      <div style={S.header}>
        <p style={S.sub}>Account Settings</p>
        <h1 style={S.title}>Teacher Profile</h1>
      </div>

      {/* ── Basic Profile ─────────────────────────── */}
      <div className="grid" style={S.grid}>
        {/* Photo column */}
        <div className="photoCol" style={S.photoCol}>
          <div
            style={S.photoWrap}
            onMouseEnter={() => setPhotoHover(true)}
            onMouseLeave={() => setPhotoHover(false)}
            onClick={() => photoInputRef.current?.click()}
          >
            <img
              src={photoSrc()}
              alt="Profile"
              style={S.photo}
              onError={(e) => {
                e.target.src = defaultAvatar;
              }}
            />
            <div style={{ ...S.photoOverlay, opacity: photoHover ? 1 : 0 }}>
              <svg width="22" height="22" fill="none" viewBox="0 0 24 24">
                <path
                  d="M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
                  stroke="#e6be5d"
                  strokeWidth="1.5"
                />
                <path
                  d="M3 9a2 2 0 0 1 2-2h.5l1-2h7l1 2H19a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9Z"
                  stroke="#e6be5d"
                  strokeWidth="1.5"
                />
              </svg>
              <span style={S.photoOverlayText}>Change</span>
            </div>
          </div>
          <input
            ref={photoInputRef}
            type="file"
            accept="image/*"
            onChange={handlePhotoChange}
            style={{ display: "none" }}
          />
          {photoFile && (
            <span
              style={{
                color: "#22c55e",
                fontSize: "11px",
                textAlign: "center",
              }}
            >
              ✓ {photoFile.name}
            </span>
          )}
          <span style={S.nameTag}>{user?.name}</span>
          <span style={S.roleTag}>{user?.role}</span>
        </div>

        {/* Fields */}
        <form onSubmit={handleSubmit}>
          <div style={S.fields}>
            <div>
              <label style={S.label}>Full Name</label>
              <input
                style={S.input}
                name="name"
                value={profile.name}
                onChange={handleChange}
                placeholder="Full Name"
                required
                onFocus={(e) => (e.target.style.borderColor = "#e6be5d")}
                onBlur={(e) => (e.target.style.borderColor = "#2a2a2a")}
              />
            </div>
            <div>
              <label style={S.label}>Email</label>
              <input
                style={S.input}
                name="email"
                type="email"
                value={profile.email}
                onChange={handleChange}
                placeholder="Email"
                required
                onFocus={(e) => (e.target.style.borderColor = "#e6be5d")}
                onBlur={(e) => (e.target.style.borderColor = "#2a2a2a")}
              />
            </div>
            <div>
              <label style={S.label}>Phone</label>
              <input
                style={S.input}
                name="phone"
                value={profile.phone}
                onChange={handleChange}
                placeholder="Phone number"
                onFocus={(e) => (e.target.style.borderColor = "#e6be5d")}
                onBlur={(e) => (e.target.style.borderColor = "#2a2a2a")}
              />
            </div>
            <div style={{ marginTop: "0.5rem" }}>
              <button type="submit" style={S.btnGold} disabled={savingProfile}>
                {savingProfile ? "Saving..." : "Save Changes"}
              </button>
            </div>
          </div>
        </form>
      </div>

      {/* ── Teacher Details ────────────────────────── */}
      <div style={S.card}>
        <p style={S.cardTitle}>🎓 Teaching Details</p>

        {loadingTeacher ? (
          <p style={{ color: "#555", fontSize: "14px" }}>Loading...</p>
        ) : (
          <form onSubmit={handleTeacherSubmit}>
            {/* Bio */}
            <div style={{ marginBottom: "1.5rem" }}>
              <label style={S.label}>Bio</label>
              <textarea
                style={S.textarea}
                name="bio"
                value={teacherProfile.bio}
                onChange={(e) =>
                  setTeacherProfile((p) => ({ ...p, bio: e.target.value }))
                }
                placeholder="Tell students about your teaching style, experience, and expertise..."
                onFocus={(e) => (e.target.style.borderColor = "#e6be5d")}
                onBlur={(e) => (e.target.style.borderColor = "#2a2a2a")}
              />
            </div>

            {/* Skills */}
            <div style={{ marginBottom: "1.5rem" }}>
              <label style={S.label}>Skills</label>
              <div style={S.skillsWrap}>
                {teacherProfile.skills.map((sk, i) => (
                  <span key={i} style={S.skillTag}>
                    {sk}
                    <button
                      type="button"
                      onClick={() => removeSkill(i)}
                      style={{
                        background: "none",
                        border: "none",
                        color: "#e6be5d",
                        cursor: "pointer",
                        padding: 0,
                        fontSize: "14px",
                        lineHeight: 1,
                      }}
                    >
                      ×
                    </button>
                  </span>
                ))}
              </div>
              <div style={{ display: "flex", gap: "8px" }}>
                <input
                  style={S.skillInput}
                  type="text"
                  placeholder="e.g. Jazz Piano, Music Theory..."
                  value={skillInput}
                  onChange={(e) => setSkillInput(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") addSkill(e);
                  }}
                  onFocus={(e) => (e.target.style.borderColor = "#e6be5d")}
                  onBlur={(e) => (e.target.style.borderColor = "#2a2a2a")}
                />
                <button type="button" style={S.btnGhost} onClick={addSkill}>
                  + Add
                </button>
              </div>
            </div>
            {/* thumbnail video */}
            <div style={{ marginTop: "20px", marginBottom: "1.5rem" }}>
              <label>Thumbnail</label>
              <br />
              <br />

              <button
                type="button"
                style={S.btnGold}
                onClick={() => thumbnailInputRef.current?.click()}
              >
                Upload Thumbnail
              </button>

              <input
                type="file"
                ref={thumbnailInputRef}
                onChange={handleThumbnailChange}
                style={{ display: "none" }}
              />
            </div>
            {/* Intro Video */}
            <div className="videoContainer" style={S.videoContainer}>
              <label style={S.label}>Intro Video</label>

              {/* VIDEO BOX */}
              <div
                style={{
                  width: "100%",
                  height: "400px",
                  position: "relative",
                  background: "#000",
                  borderRadius: "12px",
                  overflow: "hidden",
                }}
              >
                {/* VIDEO EXISTS */}
                {videoSrc() ? (
                  <>
                    {/* THUMBNAIL VIEW */}
                    {!teacherProfile.videoPlaying && (
                      <div
                        onClick={() =>
                          setTeacherProfile((p) => ({
                            ...p,
                            videoPlaying: true,
                          }))
                        }
                        style={{
                          width: "100%",
                          height: "100%",
                          position: "relative",
                          cursor: "pointer",
                        }}
                      >
                        <img
                          src={thumbnailSrc()}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />

                        {/* PLAY BUTTON */}
                        <div
                          style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: "60px",
                            height: "60px",
                            background: "rgba(0,0,0,0.6)",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#fff",
                            fontSize: "22px",
                          }}
                        >
                          ▶
                        </div>
                      </div>
                    )}

                    {/* VIDEO PLAYER */}
                    {teacherProfile.videoPlaying && (
                      <video
                        key={videoSrc()} // 🔥 FORCE reload
                        src={videoSrc()}
                        controls
                        autoPlay
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    )}
                  </>
                ) : (
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#aaa",
                    }}
                    onClick={() => videoInputRef.current?.click()}
                  >
                    Click to upload video
                  </div>
                )}
              </div>

              {/* 🔥 BUTTONS OUTSIDE VIDEO BOX (IMPORTANT FIX) */}
              <div style={{ marginTop: "10px", display: "flex", gap: "10px" }}>
                <button
                  type="button"
                  style={S.btnGhost}
                  onClick={() => videoInputRef.current?.click()}
                >
                  ✏️ Change Video
                </button>

                {teacherProfile.videoPlaying && (
                  <button
                    type="button"
                    style={S.btnGhost}
                    onClick={() =>
                      setTeacherProfile((p) => ({ ...p, videoPlaying: false }))
                    }
                  >
                    ⬅ Back to Thumbnail
                  </button>
                )}
              </div>

              {/* INPUT */}
              <input
                ref={videoInputRef}
                type="file"
                accept="video/*"
                onChange={handleVideoChange}
                style={{ display: "none" }}
              />
            </div>
            {/* <div style={{ marginBottom: "1.5rem" }}>
              <label style={S.label}>Intro Video</label>

              
              {videoSrc() ? (
                <div>
                  <video
                    key={videoSrc()}
                    src={videoSrc()}
                    controls
                    style={S.videoPreview}
                    onError={(e) => console.error("Video load error:", e)}
                  />
                  <div style={S.row}>
                    <button
                      type="button"
                      style={S.btnGhost}
                      onClick={() => videoInputRef.current?.click()}
                    >
                      ✏️ Change Video
                    </button>
                    {teacherProfile.introVideoFile && (
                      <span style={S.successBadge}>
                        ✓ New video ready: {teacherProfile.introVideoFile.name}
                      </span>
                    )}
                  </div>
                </div>
              ) : (
               
                <div
                  style={S.videoBox}
                  onClick={() => videoInputRef.current?.click()}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.borderColor = "#e6be5d")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.borderColor = "#2a2a2a")
                  }
                >
                  <svg
                    width="36"
                    height="36"
                    fill="none"
                    viewBox="0 0 24 24"
                    style={{ margin: "0 auto 10px", display: "block" }}
                  >
                    <path
                      d="M15 10l4.553-2.276A1 1 0 0121 8.723v6.554a1 1 0 01-1.447.894L15 14M3 8a2 2 0 012-2h10a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2V8Z"
                      stroke="#555"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                  </svg>
                  <p style={{ color: "#555", fontSize: "14px", margin: 0 }}>
                    Click to upload intro video
                  </p>
                  <p
                    style={{
                      color: "#333",
                      fontSize: "12px",
                      marginTop: "4px",
                    }}
                  >
                    MP4, MOV, AVI — max 100MB
                  </p>
                  {teacherProfile.introVideoFile && (
                    <p
                      style={{
                        color: "#22c55e",
                        fontSize: "12px",
                        marginTop: "8px",
                      }}
                    >
                      ✓ {teacherProfile.introVideoFile.name}
                    </p>
                  )}
                </div>
              )}

              <input
                ref={videoInputRef}
                type="file"
                accept="video/*"
                onChange={handleVideoChange}
                style={{ display: "none" }}
              />
            </div> */}

            <button type="submit" style={S.btnGold} disabled={savingTeacher}>
              {savingTeacher ? "Saving..." : "Update Teaching Profile"}
            </button>
          </form>
        )}
      </div>
      <div style={S.card}>
        <p style={S.cardTitle}>🎓 Students Comments</p>
        <div className="skills-section">
          {/* <button
            style={{
              background: "none",
              border: "none",
              color: "#1976d2",
              fontSize: "14px",
              fontWeight: "600",
              cursor: "pointer",
              textDecoration: "underline",
              padding: "0",
            }}
            onMouseOver={(e) => (e.currentTarget.style.color = "#0d47a1")}
            onMouseOut={(e) => (e.currentTarget.style.color = "#1976d2")}
            onClick={() => setShow(!show)}
          >
            View Review
          </button> */}
          {/* {show && ( */}
          <div style={{ padding: "1rem 0rem" }}>
            {comment?.length > 0 ? (
              comment.map((com, index) => (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "start",
                    gap: "0.5rem",
                    flexDirection: "column",
                    padding: "1rem",
                    marginTop: "1rem",
                    borderRadius: "20px",
                    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                    background: "rgb(26, 26, 26)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "1rem",
                    }}
                  >
                    <>
                      {com?.studentId?.image ? (
                        <img
                          src={com?.studentId?.image}
                          alt={com?.studentId?.name}
                          className="teacher-avatar"
                        />
                      ) : (
                        <div className="teacher-avatar avatar-fallback">
                          {getInitials(com?.studentId?.name)}
                        </div>
                      )}
                    </>
                    <h1
                      style={{
                        color: "rgb(255, 255, 255)",
                        fontSize: "20px",
                      }}
                    >
                      {com?.studentId?.name}
                    </h1>
                  </div>
                  <p
                    style={{
                      color: "rgb(255, 255, 255)",
                      fontSize: "16px",
                      fontWeight: "450",
                    }}
                  >
                    {com?.comment}
                  </p>
                </div>
              ))
            ) : (
              <p>Comment dose not added</p>
            )}
          </div>
          {/* )} */}
        </div>
      </div>
    </div>
  );
}
